import {
    ROUTELINE_FETCHING,
    ROUTELINE_FAILED,
    ROUTELINE_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case ROUTELINE_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };    
        case ROUTELINE_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case ROUTELINE_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
}
